/**
 * Server-side i18n helper with ICU MessageFormat support.
 *
 * Delegates key lookup + fallback to the shared translateKey() in
 * formatMessage.js (target locale → en-US → raw key).
 *
 * Server components can't use useTranslation() (client context),
 * so they call getServerTranslator(locale) instead.
 */

import { LOCALE_MESSAGES } from './i18n';
import { translateKey } from './formatMessage';

const FALLBACK_LOCALE = 'en-US';

/**
 * Returns a { t, locale } object for server components.
 *
 * @param {string} [locale] - BCP 47 locale code (e.g. 'de-DE')
 * @returns {{ t: (key: string, values?: Record<string, any>) => string, locale: string }}
 */
export function getServerTranslator(locale) {
  const resolved = (locale && locale in LOCALE_MESSAGES) ? locale : FALLBACK_LOCALE;

  function t(key, values) {
    return translateKey(resolved, key, values);
  }

  return { t, locale: resolved };
}
